export class AuthenticationRequiredError extends Error {
  public constructor(
    message = "Your session has expired. Sign in again.",
    public readonly status: number | null = null,
  ) {
    super(httpErrorMessage(message, status));
  }
}

export class AuthenticationError extends Error {}

export class ApiError extends Error {
  public constructor(
    message: string,
    public readonly status: number | null = null,
    options?: ErrorOptions,
  ) {
    super(httpErrorMessage(message, status), options);
    this.name = "ApiError";
  }
}

function httpErrorMessage(message: string, status: number | null): string {
  return status === null ? message : `HTTP ${status}: ${message}`;
}
